import type { SupportTicketListItemResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/support-ticket";

export function preserveSmsOptedOutAt(
  incoming: SupportTicketListItemResponse,
  existing: SupportTicketListItemResponse | undefined,
): SupportTicketListItemResponse {
  if (
    incoming.smsOptedOutAt === undefined &&
    existing?.smsOptedOutAt !== undefined
  ) {
    return { ...incoming, smsOptedOutAt: existing.smsOptedOutAt };
  }
  return incoming;
}
